import { render, staticRenderFns } from "./LoginFailedModal.vue?vue&type=template&id=1783d789&"
import script from "./LoginFailedModal.vue?vue&type=script&lang=ts&"
export * from "./LoginFailedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports